
  <div class="custom-icon-input-container">
    <mat-icon class="pointer">{{icon}}</mat-icon>
    <input
      type="text"
      [(ngModel)]="value"
      (input)="onChange($any($event.target).value)"
      (blur)="onTouched(); blur.emit()"
      [disabled]="disabled"
      [placeholder]="placeholder"
    >
    @if(showClear && value() !== '') {
      <mat-icon class="pointer scale-80" (click)="clearSearch()">cancel</mat-icon>
    }

  </div>
